var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoorskin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_22",
    "data-name": "Grupo 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.84,
    height: 55,
    viewBox: "0 0 168.84 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1049",
    "data-name": "Ret\\xE2ngulo 1049",
    width: 168.84,
    height: 55,
    fill: "#ffffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M21.8,28.36c0-5.891-4.24-8.574-8.179-8.574-3.2,0-5.3,1.36-7.817,3.714V19.962L0,21.794l2.733,1.822V41.822L0,44.66H8.543L5.806,41.822V24.2c1.706-1.786,3.8-3.607,6.389-3.607,4.092,0,6.537,3.849,6.537,7.57V41.822L16,44.66h8.542L21.8,41.822Z",
    transform: "translate(0 -10.562)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M66.052,19.575a12.642,12.642,0,1,0,8.956,3.752,12.625,12.625,0,0,0-8.956-3.752m9.49,15.119A10.262,10.262,0,0,1,73.4,41.369a6.833,6.833,0,0,1-5.326,2.52c-2.783,0-5.664-1.611-7.9-4.42a16.036,16.036,0,0,1-3.506-9.8A10.267,10.267,0,0,1,58.806,23a6.836,6.836,0,0,1,5.326-2.52c2.784,0,5.664,1.611,7.9,4.42a16.034,16.034,0,0,1,3.507,9.8",
    transform: "translate(-28.581 -10.449)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M124.048,19.575A12.642,12.642,0,1,0,133,23.327a12.625,12.625,0,0,0-8.956-3.752m9.49,15.119a10.262,10.262,0,0,1-2.146,6.674,6.833,6.833,0,0,1-5.326,2.52c-2.783,0-5.664-1.611-7.9-4.42a16.036,16.036,0,0,1-3.506-9.8A10.267,10.267,0,0,1,116.8,23a6.836,6.836,0,0,1,5.326-2.52c2.784,0,5.664,1.611,7.9,4.42a16.034,16.034,0,0,1,3.507,9.8",
    transform: "translate(-59.54 -10.449)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M172.14,25.849V20.013l-5.8,1.833,2.733,1.822V41.923l-2.737,2.838h8.543l-2.737-2.838V27.476a3.019,3.019,0,0,1,.962-2.243c1.282-1.24,3.846-1.891,7.05-1.784h.048l.766-3.475-.082.011c-4.8.6-7.956,1.805-8.744,5.863",
    transform: "translate(-88.791 -10.663)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M208.663,30.409q-.31-.131-.612-.261c-2.542-1.067-6.805-3.266-6.805-6,0-2.274,2.748-3.633,5.405-3.633a7.609,7.609,0,0,1,3.314.729l5.063,4.522.137.123-1.32-5.741-.01-.045h-7.183c-2.888,0-6.26,1.434-6.26,5.473,0,4.149,4.678,6.81,7.466,8.026l.241.113c3.145,1.473,7.452,3.489,7.452,6.331,0,2.492-2.725,4.371-6.34,4.371a12.713,12.713,0,0,1-4.2-.829l-5.259-4.62-.134-.117,1.318,5.933.01.046h8.266c4.2,0,7.244-2.488,7.244-5.916,0-5.193-4.32-7.029-7.791-8.5",
    transform: "translate(-106.557 -10.731)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M249.8,15.058c3.1-2.5,5.141-3.468,9.6-5.575l.234-.111h-7.009l1.4,2.252a27.176,27.176,0,0,0-7.635,6.129,13.966,13.966,0,0,0-2.511,4.153V0l-5.8,1.782,2.735,1.823V31.211L238.075,34.1h8.54l-2.735-2.887V24.589c0-3.229,2.656-6.354,3.568-7.33l7.083,14.653L252.5,34.1h7.649L257.8,31.545Z",
    transform: "translate(-127.087)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M293.977,7.758A2.273,2.273,0,1,0,291.7,5.485a2.276,2.276,0,0,0,2.273,2.273",
    transform: "translate(-155.715 -1.715)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M294.068,20.058l-5.8,1.833L291,23.712V41.967L288.262,44.8H296.8l-2.737-2.838Z",
    transform: "translate(-153.877 -10.707)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M328.267,28.162V41.822L325.53,44.66h8.542l-2.737-2.838V28.36c0-5.891-4.24-8.574-8.179-8.574-3.2,0-5.3,1.36-7.817,3.714V19.962l-5.8,1.833,2.733,1.822V41.822l-2.737,2.838h8.543l-2.737-2.838V24.2c1.706-1.786,3.8-3.607,6.389-3.607,4.092,0,6.537,3.849,6.537,7.57",
    transform: "translate(-165.233 -10.562)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M108.326,105.2a2.555,2.555,0,0,1-1.718.584,2.477,2.477,0,0,1-2.459-2.683,2.582,2.582,0,0,1,2.493-2.8,1.876,1.876,0,0,1,1.976,1.942,4.414,4.414,0,0,1-.034.528h-3.548a2.256,2.256,0,0,0-.011.269c0,1.269.7,2.234,1.841,2.234a1.855,1.855,0,0,0,1.224-.471Zm-.561-2.851c0-1.022-.46-1.594-1.19-1.594-.64,0-1.28.584-1.493,1.594Z",
    transform: "translate(-55.596 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M115.784,104.77a1.89,1.89,0,0,0,1.325.562c.752,0,1.268-.338,1.268-.9,0-.483-.381-.786-1.4-1.111s-1.5-.775-1.5-1.561c0-.763.662-1.459,1.875-1.459a3.244,3.244,0,0,1,1.617.4l-.27.628a2.066,2.066,0,0,0-1.414-.584c-.662,0-1.078.3-1.078.774s.325.741,1.3,1.078c1.179.4,1.606.831,1.606,1.572,0,.853-.662,1.606-2,1.606a3.759,3.759,0,0,1-1.617-.382Z",
    transform: "translate(-61.639 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M124.985,104.77a1.89,1.89,0,0,0,1.325.562c.752,0,1.268-.338,1.268-.9,0-.483-.381-.786-1.4-1.111s-1.5-.775-1.5-1.561c0-.763.662-1.459,1.875-1.459a3.243,3.243,0,0,1,1.617.4l-.269.628a2.066,2.066,0,0,0-1.414-.584c-.662,0-1.078.3-1.078.774s.325.741,1.3,1.078c1.179.4,1.606.831,1.606,1.572,0,.853-.662,1.606-2,1.606a3.759,3.759,0,0,1-1.617-.382Z",
    transform: "translate(-66.551 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M138.309,105.2a2.555,2.555,0,0,1-1.718.584,2.477,2.477,0,0,1-2.459-2.683,2.582,2.582,0,0,1,2.493-2.8,1.876,1.876,0,0,1,1.976,1.942,4.414,4.414,0,0,1-.034.528h-3.548a2.262,2.262,0,0,0-.011.269c0,1.269.7,2.234,1.841,2.234a1.855,1.855,0,0,0,1.224-.471Zm-.561-2.851c0-1.022-.46-1.594-1.19-1.594-.64,0-1.28.584-1.493,1.594Z",
    transform: "translate(-71.601 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M149.328,105.611v-3.334c0-.977-.359-1.325-1.055-1.325a2.184,2.184,0,0,0-1.448.842v3.817h-.809v-5.03l.809-.247v.841h.056a2.494,2.494,0,0,1,1.785-.876c.988,0,1.471.662,1.471,1.661v3.649Z",
    transform: "translate(-77.945 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M159.9,103.359a1.7,1.7,0,0,1-1.313.595c-.719,0-1.257-.415-1.257-1.572V99.115h-.842v-.472h.842V97.128l.808-.247v1.763h1.617v.472h-1.617v3.379c0,.628.269.909.651.909a1.2,1.2,0,0,0,.887-.46Z",
    transform: "translate(-83.535 -51.716)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M165.3,96.138a.585.585,0,1,1,.584.617.605.605,0,0,1-.584-.617m.18,6.915v-5.03l.808-.247v5.276Z",
    transform: "translate(-88.237 -50.984)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M173.537,105.65V105h-.045a1.968,1.968,0,0,1-1.639.82c-1.28,0-2.021-1.1-2.021-2.582a2.546,2.546,0,0,1,2.515-2.818,2.91,2.91,0,0,1,1.246.281l.752-.325v5.276Zm0-4.378a1.77,1.77,0,0,0-1.134-.4c-1,0-1.7.91-1.7,2.2s.55,2.133,1.516,2.133a1.61,1.61,0,0,0,1.313-.876Z",
    transform: "translate(-90.658 -53.581)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M182.63,102.732V95.154l.808-.248v7.825Z",
    transform: "translate(-97.49 -50.662)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M193.422,102.844v-7.69l.808-.248v3.323h.045a1.991,1.991,0,0,1,1.639-.808c1.28,0,2.021,1.1,2.021,2.582a2.546,2.546,0,0,1-2.515,2.818,3.1,3.1,0,0,1-1.257-.281Zm.808-.876a1.839,1.839,0,0,0,1.134.4c1,0,1.7-.91,1.7-2.2s-.538-2.133-1.516-2.133a1.611,1.611,0,0,0-1.313.876Z",
    transform: "translate(-103.251 -50.662)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M209,105.2a2.555,2.555,0,0,1-1.718.584,2.477,2.477,0,0,1-2.459-2.683,2.582,2.582,0,0,1,2.493-2.8,1.876,1.876,0,0,1,1.976,1.942,4.411,4.411,0,0,1-.034.528h-3.548a2.25,2.25,0,0,0-.011.269c0,1.269.7,2.234,1.841,2.234a1.855,1.855,0,0,0,1.224-.471Zm-.561-2.851c0-1.022-.46-1.594-1.19-1.594-.64,0-1.28.584-1.493,1.594Z",
    transform: "translate(-109.338 -53.542)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M219.845,105.65V105H219.8a1.968,1.968,0,0,1-1.639.82c-1.28,0-2.021-1.1-2.021-2.582a2.546,2.546,0,0,1,2.515-2.818,2.91,2.91,0,0,1,1.246.281l.752-.325v5.276Zm0-4.378a1.771,1.771,0,0,0-1.134-.4c-1,0-1.7.91-1.7,2.2s.55,2.133,1.516,2.133a1.61,1.61,0,0,0,1.313-.876Z",
    transform: "translate(-115.378 -53.581)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M232.165,105.8V105.1h-.056a2.477,2.477,0,0,1-1.786.875c-.988,0-1.471-.662-1.471-1.661v-3.649h.809V104c0,.977.37,1.325,1.055,1.325a2.161,2.161,0,0,0,1.448-.842v-3.817h.808V105.8Z",
    transform: "translate(-122.164 -53.735)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M242.969,103.359a1.7,1.7,0,0,1-1.313.595c-.719,0-1.257-.415-1.257-1.572V99.115h-.842v-.472h.842V97.128l.808-.247v1.763h1.617v.472h-1.617v3.379c0,.628.269.909.651.909a1.2,1.2,0,0,0,.887-.46Z",
    transform: "translate(-127.878 -51.716)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M250.237,105.872l-2.257-5.209h.9l1.752,4.176,1.5-4.176h.527l-2.515,6.8c-.337.91-.774,1.269-1.4,1.269a1.8,1.8,0,0,1-.73-.157l.191-.831a.921.921,0,0,0,.674.416c.4,0,.628-.27.842-.876Z",
    transform: "translate(-132.375 -53.735)",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoorskin);
export default __webpack_public_path__ + "static/media/noorskin.2b61622c50e441300d3cef15ae7df639.svg";
export { ForwardRef as ReactComponent };